import React, {cloneElement} from 'react';

import {Listbox} from '@pb/kit-component-listbox';

import {mapItems} from './utils/map-items';

import type {ComboboxItemProps} from './combo-box-item.component';
import type {ListboxProps} from '@pb/kit-component-listbox';


export interface ComboboxListboxProps<ItemValue> extends ListboxProps {
    /**
     * Allowed to select multiple items. If true - value should be an array
     * */
    multiselectable?: boolean,

    /**
     * If true - Check icon on selected item will be hidden
     * @deprecated It will be removed in 6 months 09-15-2025. use Item children instead
     * */
    dropdown?: boolean,

    /**
     * Get it from useComboboxValue
     */
    value: ItemValue[],

    /**
     * Get it from useComboboxValue
     * */
    onChange: (itemProps: ComboboxItemProps<ItemValue>) => void,

    /**
     * Get it from useComboboxValue
     * */
    isDefaultItemSelected?: boolean,
}

/**
 * ComboBox Listbox component. It is a part of ComboBox component. Use with rest of Combobox hooks.
 */
function ComboboxListbox<ItemValue>(
    props: ComboboxListboxProps<ItemValue>,
) {
    const {
        onChange,
        multiselectable,
        children,
        dropdown,
        value,
        isDefaultItemSelected,
        ...restProps
    } = props;

    return (
        <Listbox
            aria-multiselectable={multiselectable}
            {...restProps}>
            {mapItems<ItemValue>(children, child => cloneElement(child, {
                dropdown,
                selected: value.includes(child.props.value) && !isDefaultItemSelected,
                onClick: (event: React.KeyboardEvent<HTMLLIElement> | React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                    onChange(child.props);
                    child.props.onClick?.(event);
                },
            }))}
        </Listbox>
    );
}

ComboboxListbox.displayName = 'ComboboxListbox';

export {ComboboxListbox};
